import { getAppMarketPermissions } from '../selectors/appForInstallation';
import { getInstallationSourceToken } from '../services/get-installation-source-token';
import { useHandleError } from '../components/ErrorBoundary/ErrorHandlerProvider';
import { INSTALLER_ERRORS } from '../errors';
import { validateRedirectUrl } from '../utils/oauth-validations';
import { getAppUri } from '../selectors/appRuntimeReader';
import { useOauthBroadcastRedirectHandler } from './useOauthBroadcastRedirectHandler';
import { usePanorama } from '../context/PanoramaContext';
import { useInstallerContext } from '../context/InstallerContext';
export const useAdvanceOauth = () => {
  const {
    handleError
  } = useHandleError();
  const {
    preInstallationData,
    httpClient
  } = useInstallerContext();
  const {
    startTransaction,
    finishTransaction
  } = usePanorama();
  const {
    appForInstallation,
    app
  } = preInstallationData;
  const appUri = getAppUri(app);
  const authorizeTpaRedirect = useOauthBroadcastRedirectHandler();
  return async () => {
    if (!appUri) {
      return Promise.resolve(undefined);
    }
    const appUriParsed = new URL(appUri);
    startTransaction('get-oauth-source-token');
    const token = await getInstallationSourceToken({
      httpClient,
      handleError
    });
    finishTransaction('get-oauth-source-token');
    if (token) {
      appUriParsed.searchParams.set('token', token || '');
      const {
        redirectUrlAnswerFromTpa: redirectUrl,
        oauth2State
      } = await new Promise(_resolve => authorizeTpaRedirect(_resolve, appUriParsed.href));
      if (!redirectUrl) {
        await handleError(INSTALLER_ERRORS.OAUTH_ERROR_APP_URL);
        return;
      }
      const isValid = validateRedirectUrl({
        app,
        redirectUrl
      });
      if (!isValid) {
        await handleError(INSTALLER_ERRORS.REDIRECT_URL_NOT_IN_WHITELIST);
        return;
      }
      return {
        oauth2: {
          redirectUrl,
          state: oauth2State,
          permissions: getAppMarketPermissions(appForInstallation) || []
        }
      };
    } else {
      return;
    }
  };
};
//# sourceMappingURL=useAdvanceOauth.js.map